import React from 'react'
import { AuthContext } from '../../../../contexts/AuthContext'

import '../stylesPix.css'

export default function PassosPagPix() {
  const { sttAuthCtx } = React.useContext(AuthContext)

  if (sttAuthCtx.isMobile) {
    return (
      <div className='contain-mid-instructs-pix'>
        <div className='contain-line-pix'>
          <h2>1º passo</h2>
          <p>Abra o App do seu banco e vá até o menu PIX.</p>
        </div>
        <div className='contain-line-pix'>
          <h2>2º passo</h2>
          <div className='contain-line-collun-pix'>
            <p>Escolha a opção de Ler QR Code e aponte a câmera do seu celular para o QR Code ao lado</p>
            <p>Ou se preferir, você pode copiar o código e colar na opção PIX Copia e Cola do seu app bancário.</p>
          </div>
        </div>
        <div className='contain-line-pix'>
          <h2>3º passo</h2>
          <p>Confira as informações e finalize o pagamento.</p>
        </div>
        <div className='contain-line-pix'>
          <h2>4º passo</h2>
          <div className='contain-line-collun-pix'>
            <p>Pronto!</p>
            <p>O sistema já irá identificar seu pagamento e seu agendamento estará confirmado.</p>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className='contain-mid-instructs-pix'>
        <div className='contain-line-pix'>
          <h2>1</h2>
          <p>Abra o App do seu banco e vá até o menu PIX.</p>
        </div>
        <div className='contain-line-pix' style={{ alignItems: 'flex-start' }}>
          <h2>2</h2>
          <div className='contain-line-collun-pix'>
            <p>Escolha a opção de Ler QR Code e aponte a câmera do seu celular para o QR Code ao lado</p>
            <p>Ou se preferir, você pode copiar o código e colar na opção PIX Copia e Cola do seu app bancário.</p>
          </div>
        </div>
        <div className='contain-line-pix'>
          <h2>3</h2>
          <p>Confira as informações e finalize o pagamento.</p>
        </div>
        <div className='contain-line-pix' style={{ alignItems: 'flex-start' }}>
          <h2>4</h2>
          <div className='contain-line-collun-pix'>
            <p>Pronto!</p>
            <p>O sistema já irá identificar seu pagamento e seu agendamento estará confirmado.</p>
          </div>
        </div>
      </div>
    )
  }
}
